import { ITextSectionContent } from "@/sections/common/TextSection";

import certificate1 from "@/assets/images/certificates/certificate1.png";
import certificate2 from "@/assets/images/certificates/certificate2.png";
import certificate3 from "@/assets/images/certificates/certificate3.png";
import rating from "@/assets/images/certificates/rating.png";

export const ratingSectionData: {
  mainDescription: ITextSectionContent;
  certificatesAndRatings: {
    certificates?: { image: string; href: string }[];
    rating?: string;
  };
} = {
  mainDescription: {
    heading: "5-star rated by the teams we secure",
    description: (
      <>
        <p>
          60+ security and engineering teams across fintech, healthcare,
          and SaaS cite our response speed, technical depth, and CERT-In
          empanelment as the reasons they engaged us.
        </p>
      </>
    ),
    buttons: [
      {
        id: "rating-review-button",
        variant: "primary",
        text: "Read reviews on Clutch",
        link: "https://clutch.co/profile/certbar-security#reviews",
        target: "_blank",
      },
    ],
  },
  certificatesAndRatings: {
    certificates: [
      { image: certificate1.src, href: "https://clutch.co/" },
      { image: certificate2.src, href: "https://clutch.co/" },
      { image: certificate3.src, href: "https://clutch.co/" },
    ],
    rating: rating.src,
  },
};
